import React, { useState } from 'react'
import { useMutation } from '@apollo/client'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'app/rootReducer'
import './styles.scss'

import {
  UPDATE_ACCOUNT_MOBILE_PHONE,
  UpdateAccountMobilePhoneVariables,
  UpdateAccountMobilePhoneResponse,
  UpdateAccountMobilePhoneResponseData
} from 'share/mutations/account'
import { setMobilePhone } from 'reducers/authentication/authenticationSlice'
import { setMobilePhone as setUserProfileMobilePhone } from 'reducers/userprofile/userprofileSlice'
import GoBackHeader from 'components/organisms/GoBackHeader'
import UserProfileChangeMobilePhoneForm from 'components/organisms/UserProfileChangeMobilePhoneForm'
import ErrorMessage from 'components/atoms/ErrorMessage'
import useLoadingDelay from 'hooks/useLoadingDelay'
import { loadingSpinnerPortal } from 'components/atoms/LoadingSpinner'

interface Props {
  nextPage(page: string): void
  previousPage(page: string): void
}

const UserProfileChangeMobilePhone = (props: Props): JSX.Element => {
  const { nextPage, previousPage } = props
  const [submitErrorMessage, setSubmitErrorMessage] =
    useState<string | null>(null)
  const authentication = useSelector((state: RootState) => state.authentication)
  const userprofile = useSelector((state: RootState) => state.userprofile)
  const dispatch = useDispatch()

  const [updateAccountMobilePhone, { loading }] = useMutation<
    UpdateAccountMobilePhoneResponse,
    UpdateAccountMobilePhoneVariables
  >(UPDATE_ACCOUNT_MOBILE_PHONE)

  async function updateAccountMobilePhoneHelper(
    input: UpdateAccountMobilePhoneVariables
  ): Promise<UpdateAccountMobilePhoneResponseData> {
    const result: UpdateAccountMobilePhoneResponseData = {
      success: false,
      errorMessage: null
    }

    try {
      const updateAccountMobilePhoneResult = await updateAccountMobilePhone({
        variables: input
      })
      if (
        updateAccountMobilePhoneResult.data?.accounts.updateAccountMobilePhone
          .success
      ) {
        result.success = true
        dispatch(setMobilePhone(input.updateMobilePhoneData.mobilePhoneNumber))
        if (userprofile) {
          if (userprofile.mobilePhone) {
            dispatch(
              setUserProfileMobilePhone(
                input.updateMobilePhoneData.mobilePhoneNumber
              )
            )
          }
        }
      } else {
        result.success = false
        result.errorMessage =
          updateAccountMobilePhoneResult.data?.accounts.updateAccountMobilePhone.errorMessage
      }
    } catch (e) {
      result.success = false
      result.errorMessage =
        'Update Mobile Phone had an error. Please try again.'
    }
    return result
  }

  const renderFailViolator = () => {
    return (
      <ErrorMessage>
        <span>{submitErrorMessage}</span>
      </ErrorMessage>
    )
  }

  const loadingDelay = useLoadingDelay(loading)

  return (
    <React.Fragment>
      <GoBackHeader
        text='Change Mobile Phone'
        onClick={() => props.previousPage('edit')}
      />
      {loadingDelay && loadingSpinnerPortal()}
      {submitErrorMessage && renderFailViolator()}
      <div className='default-size-container ui-change-mobile-phone-page mt-4 mt-lg-5'>
        <h1>Change your mobile phone number.</h1>

        <div className='mt-4'>
          <UserProfileChangeMobilePhoneForm
            authentication={authentication}
            nextPage={nextPage}
            previousPage={previousPage}
            updateAccountMobilePhoneHelper={updateAccountMobilePhoneHelper}
            setSubmitErrorMessage={setSubmitErrorMessage}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default UserProfileChangeMobilePhone
